import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { ButtonBase } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { colors } from "../../utils";

export const StyledTooltip = styled(
  ({ className, color, textColor, width, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  )
)(({ theme, color, textColor, width }) => ({
  zIndex: `1000000 !important`,
  [`& .${tooltipClasses.tooltip}`]: {
    color: textColor || colors.black,
    fontSize: "12px",
    backgroundColor: color || colors.lightBlue,
    borderRadius: "4px",
    padding: "8px",
    width: width || "auto",
    maxWidth: width || 220,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: color || colors.lightBlue,
  },
}));

const IyugaTooltip = ({ tooltip, placement = "bottom", children, width }) => {
  const [open, setOpen] = useState(false);

  const handleTooltipClose = () => {
    setOpen(false);
  };

  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const handleTouchStart = (e) => {
    e.preventDefault();
    setOpen(true);
    // Auto-close after 3 seconds on mobile
    setTimeout(() => {
      setOpen(false);
    }, 3000);
  };

  const RenderChildren = () => {
    return children ? (
      <ButtonBase
        sx={{ alignItems: "flex-start" }}
        onTouchStart={handleTouchStart}
        onClick={handleTooltipOpen}
      >
        {children}
      </ButtonBase>
    ) : (
      <ButtonBase
        sx={{}}
        onTouchStart={handleTouchStart}
        onClick={handleTooltipOpen}
      >
        <InfoOutlinedIcon
          sx={{ p: 0, m: 0, color: "#667085" }}
          color="primary"
          fontSize="small"
        />
      </ButtonBase>
    );
  };

  return (
    <StyledTooltip
      title={tooltip}
      placement={placement}
      arrow
      width={width}
      open={open}
      onClose={handleTooltipClose}
      onOpen={handleTooltipOpen}
      disableHoverListener={false}
      disableFocusListener={false}
      disableTouchListener={true}
      slotProps={{
        popper: {
          // modifiers: [
          //   {
          //     name: "offset",
          //     options: {
          //       offset: [0, -5],
          //     },
          //   },
          // ],
        },
      }}
    >
      {RenderChildren()}
    </StyledTooltip>
  );
};

export default IyugaTooltip;
